import { useContext } from 'react';

import { AppContext } from '@r-app/app-context';
import { CreateBlueprintSymbols } from '../symbols';
import { DisplayMode } from '@r-core';
import { renderTracking } from '@r-services/render-tracking';
import { DisplayInlineMode, DisplayOverheadMode, DisplayPanelMode } from '../display-mode';
import { RenderBacksplashes } from './render-backsplashes';
import { RenderCornerTrims } from './render-corner-trims';
// ExampleControllerUsage component was removed - using direct controller access instead


type RenderBlueprintProps = {
	children?: React.ReactElement | Array<React.ReactElement>
}

export const RenderBlueprint = ({ children }: RenderBlueprintProps): React.ReactElement => {
	const { controller } = useContext(AppContext);
	// const layerNodes: RenderLayerNodes = [];

	let displayModeElement: React.ReactElement = <></>;

	// Only try to access navigation if controller exists
	if (controller?.navigation) {
		switch (controller.navigation.displayMode) {
			case DisplayMode.Inline:
			case DisplayMode.InlineManufacturing:
				displayModeElement = <DisplayInlineMode/>;
				break;
			case DisplayMode.Overhead:
			case DisplayMode.OverheadManufacturing:
			case DisplayMode.SkuOverhead:
			case DisplayMode.SkuOverheadManufacturing:
				displayModeElement = <DisplayOverheadMode/>;
				break;
			case DisplayMode.Backsplash:
			case DisplayMode.BacksplashManufacturing:
				displayModeElement = <RenderBacksplashes/>;
				break;
			case DisplayMode.CornerTrim:
			case DisplayMode.CornerTrimManufacturing:
				displayModeElement = <RenderCornerTrims/>;
				break;
			case DisplayMode.BlueprintView:
				displayModeElement = <></>;
				break;
			default:
				displayModeElement = <DisplayPanelMode/>;
				break;
		}
	}

	renderTracking.incrementRender('RenderBlueprint');
	return <>
		<CreateBlueprintSymbols />
		{ displayModeElement }
		{/* <RenderLayers/> */}
		{/* <RenderLayerDemo /> */}
		{ children }
	</>;
};

